import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/mushroom.png";
import sliced from "../../assets/images/ingredients/mushroom_cut.png";

const Mushroom = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Mushroom"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Mushroom;